import { useEffect } from 'react';
import { usePriorityRendererShallowStore } from '../store/priority-renderer.store';

export const useInitPriorityRendererGroup = ({
  groupName,
  priorityList,
  resetPriorityMap = false,
  stabilizationTimeout,
}: {
  groupName: string;
  priorityList: string[];
  resetPriorityMap?: boolean;
  /**
   * Time in milliseconds to wait for all items to register before stabilizing the group.
   * Once stabilized, the top priority item becomes visible.
   * Default is 150ms.
   */
  stabilizationTimeout?: number;
}) => {
  const { initializeGroup } = usePriorityRendererShallowStore('initializeGroup');
  useEffect(() => {
    initializeGroup?.({ groupName, priorityList, resetPriorityMap, stabilizationTimeout });
  }, [groupName, priorityList, initializeGroup, resetPriorityMap, stabilizationTimeout]);
};
